<template>
  <div>
    <svg
      :viewBox="this.viewBox"
      ref="svg"
      width="3rem"
      :height="this.eye.height + 15"
    >
    <defs>
      <linearGradient id="hback" x2="0" y2="100%">
        <stop offset="0%" stop-color="#DEEDF2" />
        <stop offset="100%" stop-color="#FCFDFE" />
      </linearGradient>
    </defs>

    <path
        ref="bezierPath"
        fill="none"
        class="horizontal-gradient"
        :d="this.pathData"
        stroke="#A5CAD8" stroke-width="1"
      />
    </svg>
  </div>
</template>

<script>
import { ref } from 'vue';
import { decodeFormas } from '@/helpers/formulas';
import eventBus from '@/helpers/eventBus';

export default {
  setup(){
    const svg = ref(null);
    const bezierPath = ref(null);

    return {
      svg,
      bezierPath,
    }
  },
  props: {
    eye: {
      type: Object,
      required: true,
    },
  },
  data: () => ({
    posicion: 0,
    escala: 3.32,
    precision: 100,
    numeroPuntos: 600, // fijado de base
    puntosM: [],
    puntosN: [],
    pathData: '',
    viewBox: '0 -140 10 280',
    ajustes: {},
  }),
  async mounted() {
    eventBus.$on('pointOnCircle', ({ posicion, totalPuntos, forma, ojo }) => {
      if (ojo.name === this.eye.name) {
        this.puntosM = decodeFormas(ojo.FormaMO, this.precision, this.numeroPuntos)
        this.puntosN = decodeFormas(ojo.FormaNO, this.precision, this.numeroPuntos)

        this.posicion = posicion;
        this.calculateSection(this.posicion, totalPuntos, forma);
      }
    });

    if (this.eye.name === 'oi') {
      this.viewBox = '0 -140 10 280';
    } else {
      this.viewBox = '-10 -140 10 280';
    }
  },
  methods: {
    // ...mapActions(['LoadInfo']),
    calculateSection(pos, totalPuntos, forma) {
      const posicion2 = (totalPuntos / 2 + pos) % totalPuntos;
      const f1 = parseFloat(this.eye.f1) * this.escala;
      const f2 = parseFloat(this.eye.f2) * this.escala;

      const svg = this.$refs.svg;

      const p0x = this.puntosM[pos] * this.escala * (this.eye.name === 'oi' ? 1 : -1);
      const p0y = forma[pos] * -1 * this.escala;

      const p1x = this.puntosN[pos] * this.escala * (this.eye.name === 'oi' ? 1 : -1);
      const p1y = forma[pos] * -1 * this.escala;

      const p2x = f2 * (this.eye.name === 'oi' ? 1 : -1);
      const p2y = 0;

      const p3x = this.puntosN[posicion2] * this.escala * (this.eye.name === 'oi' ? 1 : -1);
      const p3y = forma[posicion2] * this.escala;

      const p4x = this.puntosM[posicion2] * this.escala * (this.eye.name === 'oi' ? 1 : -1);
      const p4y = forma[posicion2] * this.escala;

      const p5x = f1 * (this.eye.name === 'oi' ? 1 : -1);
      const p5y = 0;

      this.pathData = `M${p0x},${p0y} L${p1x},${p1y} Q${p2x},${p2y} ${p3x},${p3y} L${p4x},${p4y} Q${p5x},${p5y} ${p0x},${p0y} Z`;
      // this.eye.name === 'od'

      // const maxX = Math.max(Math.abs(p0x), Math.abs(p1x), Math.abs(p2x), Math.abs(p3x), Math.abs(p4x), Math.abs(p5x));
      // const maxY = Math.max(Math.abs(p0y), Math.abs(p1y), Math.abs(p2y), Math.abs(p3y), Math.abs(p4y), Math.abs(p5y));
      // const margin = Math.max(maxX, maxY) * 0.01;
      // console.log('margin:', margin);
      // this.viewBox = `${-maxX-margin} ${-maxY-margin} ${(maxX+margin)*2} ${(maxY+margin)*2}`;
    }
  }
}
</script>

<style lang="scss" scoped>
  .horizontal-gradient {
      fill:url(#hback);
  }
</style>
